import React, { useEffect, useState } from 'react';
import { isFirstRun, markWelcomed, startTour, onOpenWelcome } from '../lib/onboarding';

/* First-run welcome. Shows once per user (localStorage); replayable from the
 * "?" menu via the fti-open-welcome event. Orients the user, then offers the
 * guided tour or "explore on my own". Audience: procurement/contracting officers. */
export default function WelcomeModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (isFirstRun()) {
      // Small delay so the app shell renders first.
      const t = setTimeout(() => setOpen(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  useEffect(() => onOpenWelcome(() => setOpen(true)), []);

  if (!open) return null;

  const close = () => { markWelcomed(); setOpen(false); };
  const take = () => { markWelcomed(); setOpen(false); setTimeout(() => startTour(), 200); };

  const feature = (icon: string, title: string, desc: string) => (
    <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
      <div style={{ fontSize: 20, lineHeight: 1 }} aria-hidden="true">{icon}</div>
      <div>
        <div style={{ fontSize: 13, fontWeight: 600, color: '#1f2937' }}>{title}</div>
        <div style={{ fontSize: 12, color: '#6b7280', marginTop: 1 }}>{desc}</div>
      </div>
    </div>
  );

  return (
    <div role="dialog" aria-modal="true" aria-label="Welcome"
      style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.55)', zIndex: 4000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ background: 'white', borderRadius: 12, maxWidth: 560, width: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.3)', overflow: 'hidden' }}>
        <div style={{ background: '#1a2744', padding: '22px 24px' }}>
          <div style={{ color: 'white', fontSize: 18, fontWeight: 700 }}>Welcome to FTI Procurement Intelligence</div>
          <div style={{ color: '#93c5fd', fontSize: 13, marginTop: 4 }}>
            Run a federal procurement end-to-end — discovery, market research, vendor matching, and the FAR lifecycle.
          </div>
        </div>
        <div style={{ padding: '20px 24px', display: 'flex', flexDirection: 'column', gap: 14 }}>
          {feature('🔎', 'Discover & research', 'Search 1.1M+ SAM.gov notices and awards; benchmark prices and vendors.')}
          {feature('🏢', 'Know the supplier base', 'Vendor profiles with past awards and subcontracting history.')}
          {feature('📋', 'Work the lifecycle', 'Intake (FAR 11) → Acquisition (FAR 12–15) → Matching → Evaluation → Award, with AI assist and a stage guide at each step.')}
          {feature('🧮', 'Estimate cost (IGCE)', 'Describe the work and get a grounded cost range from real award data.')}
        </div>
        <div style={{ padding: '0 24px 22px', display: 'flex', gap: 10, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
          <button onClick={close}
            style={{ padding: '10px 16px', background: 'white', color: '#4b5563', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
            Explore on my own
          </button>
          <button onClick={take}
            style={{ padding: '10px 18px', background: '#4f46e5', color: 'white', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
            Take the 60-second tour
          </button>
        </div>
      </div>
    </div>
  );
}
